export default __webpack_public_path__ + "static/media/main-image-001.569a29f9.png";